import queryString from 'query-string';
import { APPLICATION_NAME } from '../analytics/segment-abstract';
import { pick } from './fp';

export type QueryParams = { [key: string]: string };

const REGISTRATION_FORM_PARAMS = [
    'locale',
    'homePage',
    'callToActionChoiceFacebook',
    'callToActionChoiceEmail',
    'callToActionEmailSubmit',
    'couponCode',
    'mode',
    'partner',
    'referralCode',
    'utm_source',
    'utm_campaign',
    'utm_medium',
    'utm_content',
    'utm_term',
    'token',
    'showRememberMe',
];

/**
 * Returns the registration form iframe url with query params
 * @param lang language to display the form
 * @param params additional params to pass to registration form
 * @param route Registration form page to display (defaults to /)
 */
export function getRegistrationFormUrl(
    lang: string,
    params: QueryParams,
    route?: string,
): string | null {
    if (!lang || !params) {
        return null;
    }

    route = route ? `#!${route}` : '';

    let registrationFormParams = {
        locale: lang,
        mode: 'loginAndSignup',
        theme: 'dark',
        showRememberMe: 'yes',
        app: APPLICATION_NAME,
        ...pick(params, REGISTRATION_FORM_PARAMS),
    };

    /**
     * The user is invited via the Collaboration flow.
     * Let's ensure the UTMs are included.
     */
    if (params.code) {
        registrationFormParams.utm_source = 'landr_collaboration';
        registrationFormParams.utm_campaign = 'CollaborationSharedLink';
        registrationFormParams.utm_medium = 'shared_link';
    }

    // The route variable needs to be at the end of the URL in order for the query
    // params to be correctly parsed and sent to analytics
    const result = `${
        process.env.GATSBY_LANDR_CDN_URL
    }/apps/RegistrationForm.v4/index.html?${queryString.stringify(registrationFormParams)}${route}`;

    return result;
}
